module.exports = __webpack_public_path__ + "static/media/inviter-title.6e03160a.png";